
import { getGroupList } from "@/api/kaisha.api";
import { dateFormat } from "@/utils/date";
import { defineComponent, PropType, reactive, ref } from "vue";
import { DialogGenre } from "@/interfaces/common.interface";
import { tableConfig, filterTableConfig } from "./tableConfig";
import Dialog from "./Dialog.vue";
import { ELEMENT_ACCESS } from "@/constants/accessList.constant";
import useDialog from "@/hooks/useDialog";
import useTable from "@/hooks/useTable";
import { QueryGroup } from "@/interfaces/kaisha.interface";
import { GroupInfo } from "@/interfaces/kaisha.interface";

export default defineComponent({
  components: {
    Dialog,
  },
  props: {
    isDialogMode: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  emits: ["select"],
  setup() {
    const table = reactive({
      queryForm: {
        kaishaNm: "",
        groupNm: "",
        page: 1,
        limit: 20,
      } as QueryGroup,
      list: [] as GroupInfo[],
      total: 0,
      loading: true,
    });
    const filteredTableConifg = filterTableConfig(tableConfig);
    console.log(filteredTableConifg);

    // 検索
    //検索メイン処理
    const getList = async () => {
      table.loading = true;
      table.list = [];
      const { data } = await getGroupList(table.queryForm);

      const { listData, total } = data.result;

      table.total = total;
      for (let i = 0; i < listData.length; i++) {
        table.list.push({
          id: listData[i].id,
          groupId: listData[i].kaisha_group_id,
          groupNm: listData[i].kaisha_group_nm,
          kaishaCd: listData[i].kaisha.kaisha_cd,
          kaishaNm: listData[i].kaisha.kaisha_nm,
          unyoNm: listData[i].kaisha.unyo.unyo_kubun,
          createdDate: dateFormat(listData[i].toroku_date),
          updatedDate: dateFormat(listData[i].koshin_date),
          mukoDate: listData[i].muko_flg
            ? dateFormat(listData[i].muko_date)
            : "",
          mukoFlg: listData[i].muko_flg,
        });
      }
      table.loading = false;
    };

    //テーブル行数変更イベント,検索イベント,クリアイベント
    const tableRef = ref();
    const { handleSizeChange, handleSearch, handleClear } = useTable(
      table,
      getList,
      tableRef
    );

    //ダイアログ利用
    const { dialogTitle, dialogOperation, openDialog } =
      useDialog("会社グループ");

    //初期表示時検索
    getList();

    return {
      table,
      filteredTableConifg,
      getList,
      handleClear,
      handleSearch,
      DialogGenre,
      dialogTitle,
      dialogOperation,
      openDialog,
      handleSizeChange,
      ELEMENT_ACCESS,
      tableRef,
    };
  },
});
